/**
 * SiteUP CRM: prévia de texto para o card do Kanban e para a vista Lista.
 *
 * A última mensagem da conversa chega com a marcação original (negrito com
 * **, itálico com _, código com crase, citação com >, links em markdown).
 * Na prévia esses símbolos aparecem crus, então a limpeza acontece aqui,
 * num helper puro, e o mesmo resultado serve às duas telas.
 */

const MARKDOWN_IMAGE = /!\[([^\]]*)\]\([^)]*\)/g;
const MARKDOWN_LINK = /\[([^\]]*)\]\([^)]*\)/g;
const CODE_FENCE = /```+/g;
const HEADING = /^\s{0,3}#{1,6}\s+/gm;
const QUOTE = /^\s{0,3}>+\s?/gm;
const LIST_MARKER = /^\s{0,3}[-*+]\s+/gm;
const HORIZONTAL_RULE = /^\s{0,3}([-*_])\1{2,}\s*$/gm;
const EMPHASIS = /(\*{1,3}|~{2}|`+)/g;
// Sublinhado só conta como marcação na borda da palavra: snake_case e
// títulos como "teste _13h26" ficam como estão no meio da palavra.
const UNDERSCORE_EMPHASIS =
  /(^|[\s(])_{1,3}(?=\S)|(?<=\S)_{1,3}(?=$|[\s).,!?;:])/g;

/**
 * Remove a marcação markdown de um texto e colapsa os espaços.
 * @param {string} text Texto original, possivelmente com markdown.
 * @returns {string} Texto em uma linha, sem marcação e sem espaço sobrando.
 */
export const stripMarkdown = text => {
  if (typeof text !== 'string' || !text) return '';

  return text
    .replace(MARKDOWN_IMAGE, '$1')
    .replace(MARKDOWN_LINK, '$1')
    .replace(CODE_FENCE, ' ')
    .replace(HORIZONTAL_RULE, ' ')
    .replace(HEADING, '')
    .replace(QUOTE, '')
    .replace(LIST_MARKER, '')
    .replace(EMPHASIS, '')
    .replace(UNDERSCORE_EMPHASIS, '$1')
    .replace(/\\([\\`*_{}[\]()#+\-.!>])/g, '$1')
    .replace(/\s+/g, ' ')
    .trim();
};

/**
 * Prévia pronta para exibir: sem markdown, em uma linha e com reticências.
 * @param {string} text Texto original.
 * @param {number} maxLength Tamanho máximo antes das reticências.
 * @returns {string} Prévia limpa.
 */
export const buildMessagePreview = (text, maxLength = 40) => {
  const clean = stripMarkdown(text);
  if (!clean) return '';
  if (!Number.isFinite(maxLength) || maxLength <= 0) return clean;

  return clean.length > maxLength
    ? `${clean.substring(0, maxLength)}...`
    : clean;
};

export default { stripMarkdown, buildMessagePreview };
